import { useContext } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import FormControl from '@mui/material/FormControl'
import Grid, { GridProps } from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { CvsAutoComplete } from '@components'
import { useIntegrationAssignment } from '@global/hooks'
import { templateCopyContext } from '../../../../context'

const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
const TypographyBold = styled(Typography)`
  weight: 500;
`
const GridMargin = styled(Grid)<GridProps>`
  margin-top: 16px;
  margin-bottom: 16px;
  flex-direction: column;
`

interface SyncScheduleProps {
  integrationOptions: {
    label: string
    value: string
  }[]
  syncSelection: string
  disabled?: boolean
  integrationAssignment: any
}

export const SyncSchedule = ({
  integrationOptions,
  syncSelection,
  disabled,
  integrationAssignment,
}: SyncScheduleProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { onIntegrationMetadataChange } = useIntegrationAssignment({
    integrationAssignment,
    onChange,
  })

  return (
    <GridMargin container component={FormControl}>
      <TypographyBold variant="h4">{t`Schedule sync`}</TypographyBold>
      <NoMarginTypography variant="body2">
        {t`Select the frequency at which this integration should sync data`}
      </NoMarginTypography>
      <CvsAutoComplete
        margin="dense"
        label={t`Sync schedule`}
        options={integrationOptions as never}
        selected={syncSelection}
        onSelected={value => {
          onIntegrationMetadataChange(value, 'sync_schedule')
        }}
        disabled={disabled}
      />
    </GridMargin>
  )
}
